'use client'

import { transformPresets, useViewportScale } from 'src/hooks/useViewportScale'
import { NotificationsStack } from 'src/features/notification'
import { useUnclaimedItemNotifications, useAutoClaimFreeBets } from 'src/features/inventory/hooks'
import { BroadcastControls } from '../BroadcastControls'
import { BalanceContainer } from './Balance/BalanceContainer'
import { ToolbarInfoContainer } from './ToolbarInfo/ToolbarInfoContainer'
import { Logo } from './Logo/Logo'

type Props = Readonly<{
  showLogo?: boolean
  onToggleSidebar: () => void
  isSidebarOpen: boolean
}>

export function GameTopToolbar({ showLogo = false, onToggleSidebar, isSidebarOpen }: Props) {
  const scaleStyle = useViewportScale({
    transform: transformPresets.basic
  })

  // Handle unclaimed item notifications (boosters, and free bets when auto-claim is off)
  useUnclaimedItemNotifications()
  // Auto-claim free bets + one aggregated grant banner (when enabled)
  useAutoClaimFreeBets()

  return (
    <div className="game-top-toolbar" style={scaleStyle}>
      <NotificationsStack />

      <div className="game-top-toolbar__inner">
        {showLogo ? <Logo /> : null}
        <ToolbarInfoContainer />
        <div className="game-top-toolbar__right">
          <BroadcastControls />

          <BalanceContainer isSidebarOpen={isSidebarOpen} onToggleSidebar={onToggleSidebar} />
        </div>
      </div>
    </div>
  )
}
